import { render, staticRenderFns } from "./ManterUnidadesTematicasView.vue?vue&type=template&id=52d28b91"
import script from "./ManterUnidadesTematicasView.vue?vue&type=script&lang=js"
export * from "./ManterUnidadesTematicasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports